import type { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';
import CircularProgress from '@mui/material/CircularProgress';
import { isNullish } from '@witmetrics/utils/misc';
import { classes, styles } from './utils';

export type SpinnerProps = {
  className?: string;
  size?: number;
  thickness?: number;
  progress?: number;
  style?: CSSProperties;
  onClick?: () => void;
};

export default function Spinner({
  className,
  size = 40,
  thickness = 5,
  progress,
  ...props
}: SpinnerProps) {
  // eslint-disable-next-line witmetrics/no-multiline-comments
  /*
    "determinate" for the background ring
    "indeterminate" for spinner when `progress` prop undefined
    "determinate" for spinner when `progress` prop is provided
   */

  return (
    <div className={twMerge(classes.wrapper, className)} {...props}>
      <CircularProgress
        sx={styles.background}
        variant="determinate"
        size={size}
        thickness={thickness}
        value={100}
      />
      {isNullish(progress) ? (
        <CircularProgress
          disableShrink
          sx={styles.spinner}
          variant="indeterminate"
          size={size}
          thickness={thickness}
        />
      ) : (
        <CircularProgress
          sx={styles.spinner}
          variant="determinate"
          size={size}
          thickness={thickness}
          value={progress}
        />
      )}
    </div>
  );
}
